import { defaultBooleanValue } from '@/_schemas/generic';
import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type BrandFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: BrandFormSchema = {
  id: -1,
  name: '',
  website: '',
  email: '',
  billing_email_address: '',
  status: defaultStatus,
  code: '',
  logo: null,
  logo_light: null,
  icon: null,
  agreement_logo: null,
  agreement_statement: '',
  invoice_disclaimer: '',
  legal_name: '',
  online_payment_url: '',
  addresses: [],
  phone_numbers: [],
  payable_to: '',
  invoice_logo: null,
  hide_online_payments: defaultBooleanValue(),
};

export const breadcrumbsLinks: RouteListItem[] = [settingsBcLink, { path: '/settings/brands', name: 'Brands' }];
